module.exports = __webpack_public_path__ + "img/terra-gers.fd0f2816.png";